---
en:
  general:
    24h_stats: 24h stats
    5min_stats: 5min stats
    7d_stats: 7days stats
    access_level:
      admin: Admin
      developer: Developer
      editor: Editor
      landowner: Landowner
      portfolio: Portfolio
    access_rights: Access rights
    action_might_be_irreversible: This action might be irreversible.
    activate: Activate
    active: Active
    activity: Activity
    actual: Actual
    add: Add
    add_as_custom_chart: Add as custom chart?
    add_attachment: Add attachment
    add_image: Add image
    add_new: Add new
    add_power-plant-supplier_connection: Add power plant supplier connection
    add_supplier_role: Add supplier role
    add_user: Add user
    admin: Admin
    all: All
    all_caps: ALL
    and: and
    apply: Apply
    are_you_sure: Are you sure?
    area: Area
    area_price: Area price
    asset_class: Asset class
    avail_analysis: Availability analysis
    availability_calculation: Availability calculation
    average_last_24_hours: 24H avg.
    avg_price: Avg price
    back: Back
    back_to_list: Back to list
    basic: Basic
    basic_details: Basic details
    bilateral: Bilateral
    budget: Budget
    budget_lowercase: budget
    budgets: Budgets
    bulk_edit_hint: Paste numbers directly from Excel; use Tab-separated values for volume then revenue.
    bulk_update: Bulk update
    cancel: Cancel
    cant_delete_company: Cannot delete company
    capacity: Capacity
    card_description: Card description
    category: Category
    chart_title: Chart title
    click_to_load_more: Click to load more
    climate_futures_inflow: Climate Futures inflow
    close: Close
    commercial_details: Commercial details
    community: Community
    companies: Companies
    company: Company
    company_access: Company Access
    confirm: Confirm
    confirmed: Confirmed
    connections: Connections
    contact_kaiasolutions: Switch to an individual portfolio with access, or contact Portal staff if you want to activate this feature.
    contract_deleted: Contract deleted
    contract_details: Contract Details
    contract_type: Contract type
    contracts_admin: Contracts Admin
    copied: Copied!
    copy: Copy
    country: Country
    county: County
    create: Create
    created: Created
    custom_lower_limit: Custom lower limit
    custom_unit: Custom unit
    custom_upper_limit: Custom upper limit
    daily: Daily
    data_source: Data Source
    data_source_configuration: Data source configuration
    date: Date
    date_from: From
    date_scope: Date
    date_to: To
    days: days
    de: German
    deactivate: Deactivate
    delete: Delete
    delete_all: Delete all
    delete_failed: Delete failed
    deleted: Deleted
    description: Description
    details: Details
    deviation: Deviation
    download: Download
    edit: Edit
    edit_supplier_role: Edit supplier role
    edit_user: Edit user
    elcert: Elcert
    elcert/GoO: Elcert / GoO
    elcert_full: Elcertificates
    email: Email
    en: English
    end_date: End date
    energy: Energy
    error: An error occurred. Please try again.
    error_reset_password: Error resetting password
    est_resource: Est. resource
    event: Event
    export_access: Export access
    feature_configuration: Feature configuration
    filter: filter
    filter_by_company: Filter by company
    filter_data: Filter data
    first_name: First name
    flip_sign: Flip sign
    forecast: Forecast
    forecast_lowercase: forecast
    fr: French
    general: General
    go_expiry_date: GO expiry date
    go_full: Guarantee of origin
    gwh: GWh
    half_yearly: Half yearly
    hide: Hide
    hourly: Hourly
    hours: Hours
    hydro: Hydro
    image: Image
    inactive: Inactive
    inflow: Inflow
    intake: Intake
    ip: IP
    language: Language
    last_activity: Last activity
    last_name: Last name
    limit: Limit
    links: Links
    lock_account: Lock account
    logged_in_successfully: Logged in successfully
    login: Log in
    login_failed: Login failed
    login_failures: Login failures
    logo: Logo
    metering_point: Metering point
    month: Month
    monthly: Monthly
    mw: MW
    name: Name
    nb: Norwegian
    new: new
    'no': 'No'
    no_image_available: No image available
    none: None
    not_enabled: is not enabled for selected portfolio or all portfolios in the Global selection.
    not_specified: Not specified
    now: now
    number_of_power_plants: Number of power plants
    nve_metadata: NVE metadata
    ny_budget: NY budget
    offset: Offset
    operational_state: Operational state
    or: or
    org_no: Org. no.
    other_info: Other info
    overview: Overview
    pareto: Pareto
    password: Password
    path: Path
    power_plant: Power plant
    power_plant_lowercase: power plant
    power_plant_names: Power plant names
    power_plants: Power plants
    power_plants_lowercase: power plants
    power_prices: Power prices
    power_production: Power production
    power_sales: Power sales
    precipitation: Precipitation
    price: Price
    price_area: Price area
    production: Production
    production_budget: Production Budget
    production_forecast: Forecasted production
    profile: Profile
    profile_lowercase: profile
    project: Project
    quarterly: Quarterly
    radiation: Radiation
    remove: Remove
    remove_attachment: Remove attachment
    remove_image: Remove image
    report_generated: Report generated
    requests: Requests
    reset: Reset
    reset_password: Reset password
    resolution: Resolution
    result: Result
    result_lowercase: result
    retry: Retry
    revenue: Revenue
    revenue_budget: Revenue Budget
    rotate: Rotate
    runoff: Runoff
    save: Save
    save_successful: Save successful
    saved: Saved
    scale_factor: Scale factor
    search: Search
    search_by: Search by name, email or access level
    search_by_name: Search by name
    search_companies: Search companies
    search_counties: Search counties
    search_powerplants: Search power plants
    seconds: Seconds
    select: Select
    select_asset_type: Select asset type
    select_columns: Select columns
    selection: Selection
    send: Send
    sensors: Nest sensors
    show: Show
    show_edit: Show/Edit
    show_less: Show less
    show_more: Show %{count} more
    show_subsidiaries: Show subsidiaries
    slowest: Slowest
    snow: Snow
    solar: Solar
    solar_backend_configuration: Solar backend configuration
    sort_by: Sort by
    spot_price: Spot price
    start_date: Start date
    statistics: Statistics
    status: Status
    summary: Summary
    supplier_contact_email: Supplier contact email
    supplier_contact_phone: Supplier contact phone
    supplier_name: Supplier name
    temperature: Temperature
    tertiary: Tertiary
    timestamp: Timestamp
    title: Title
    to: to
    today: Today
    token: Token
    top: Top
    total: Total
    total_production: Total production
    trend_last_24_hours: 24H trend
    treshold_mw: Treshold MW
    unexpected_error: Unexpected error
    unknown: Unknown
    unknown_error: Something went wrong
    unlock_account: Unlock account
    unsaved_changes: You have unsaved changes.
    update: Update
    updated: Updated
    user_access_level: Access level
    valid_contract: Valid contract
    validations:
      non_negative: Non negative
      required: Required
    view_details: View details
    volume: Volume
    volume_percent: Volume percent
    weekly: Weekly
    welcome: Welcome
    wind: Wind
    wind_backend_configuration: Wind backend configuration
    wind_speed: Wind speed
    wrong_email_or_password: Wrong email address or password
    year: Year
    yearly: Yearly
    'yes': 'Yes'
